import React from 'react';
import Modal from '@saucelabs/ds-modal';
import { modalConnectV2 } from '@saucelabs/sl-container-modal';
import { IconBulletChecked } from '@saucelabs/sl-component-icons';

import { FeatureList } from './Plans/FeatureList';
import { CROSS_BROWSER_FEATURES_MODAL } from '../constants';

interface Props {
  isAutomatedTab: boolean,
}

const CrossBrowserFeaturesModal: React.FC<Props> = ({
  isAutomatedTab,
}) => (
  <Modal
    data-qa="cross-browser-features-modal"
    emphasis="low"
    title="Cross-Browser and Mobile App Testing"
  >
    <FeatureList.Header>
      Includes:
    </FeatureList.Header>
    <FeatureList isColumn>
      <li>
        <IconBulletChecked />
        Native &amp; Hybrid Mobile App Testing
      </li>
      <li>
        <IconBulletChecked />
        Unlimited Users
      </li>
      <li>
        <IconBulletChecked />
        Cross-Browser Testing
      </li>
      <li>
        <IconBulletChecked />
        Unlimited Testing Minutes
      </li>
      {isAutomatedTab && (
        <>
          <li>
            <IconBulletChecked />
            Mobile App Automated Testing
          </li>
          <li>
            <IconBulletChecked />
            Performance, Insights, &amp; Analytics
          </li>
          <li>
            <IconBulletChecked />
            Local &amp; JavaScript Testing
          </li>
          <li>
            <IconBulletChecked />
            Secure Tunneling &amp; APIs
          </li>
        </>
      )}
    </FeatureList>
  </Modal>
);

export default modalConnectV2<Props>(CROSS_BROWSER_FEATURES_MODAL, CrossBrowserFeaturesModal);
export { CrossBrowserFeaturesModal };
